import { render, staticRenderFns } from "./PunchPlace.vue?vue&type=template&id=343ddcca&scoped=true&"
import script from "./PunchPlace.vue?vue&type=script&lang=js&"
export * from "./PunchPlace.vue?vue&type=script&lang=js&"
import style0 from "./PunchPlace.vue?vue&type=style&index=0&id=343ddcca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343ddcca",
  null
  
)

export default component.exports